export default (b: boolean) => !b;
